export default {"src":"/_next/static/media/scroll-2.d4977144.gif","height":400,"width":400,"blurWidth":0,"blurHeight":0};